import { useEffect, useState } from 'react';
import { getOrderReceiptsZipDetails } from 'src/components/selfService/features/OrderHistory/ZipDownload/hooks/OrderReceiptsZipApi';
import {
  OrderReceiptsZipDetailsData,
  transformOrderReceiptsZipDetailsAPIToUIModel,
  ZipDetailsResponse,
  ZipFileStatus,
} from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { pushErrorFromAPI } from 'src/utilities/notifications';

interface UseOrderReceiptsZipDetailsProps {
  corpId: string;
}

export const useOrderReceiptsZipDetails = ({
  corpId,
}: UseOrderReceiptsZipDetailsProps): OrderReceiptsZipDetailsData => {
  const [orderReceiptsZipDetails, setOrderReceiptsZipDetails] =
    useState<OrderReceiptsZipDetailsData>({
      maximumReceiptsAllowed: 0,
      status: ZipFileStatus.IDLE,
      filters: null,
    });

  const fetchDetails = async () => {
    try {
      const response: ZipDetailsResponse = await getOrderReceiptsZipDetails(
        corpId
      );
      const transformedOrderReceiptsZipDetails =
        transformOrderReceiptsZipDetailsAPIToUIModel(response);
      setOrderReceiptsZipDetails(transformedOrderReceiptsZipDetails);
    } catch (error) {
      pushErrorFromAPI(error);
    }
  };

  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return orderReceiptsZipDetails;
};
